/**
 * Représentation d'une option de filtre
 */
export class FiltreOption {
    libelle: string;
    valeur: number;
    avatar: string;
    libelleListe?: string;
    modificateur?: string;
}

/**
 * Enum des types de filtre
 */
export enum TypeFiltreDigit {
    FILTRE_MOT_CLE = 1,
    FILTRE_TYPE_ENTITE = 2,
    FILTRE_CATEGORIE = 3,
    FILTRE_ORGANISATION = 4,
    FILTRE_CODE_ACTIVITE = 5,
    FILTRE_TYPE_CHARGE = 6,
    FILTRE_RUBRIQUE = 8
}